import { Injectable, computed, signal } from '@angular/core';
@Injectable({
  providedIn: 'root',
})
export class AuthMobileService {
  #lastMobileNumber = signal<string>('');
  #lastUserGuid = signal<string>('');
  #timerValue = signal<number>(0);
  #timerSubscription = signal<any>(null);

  lastMobileNumber = computed(this.#lastMobileNumber);
  lastUserGuid = computed(this.#lastUserGuid);
  timerValue = computed(this.#timerValue);
  lastTimerSubscriptions = computed(this.#timerSubscription);
  constructor() {}

  setLastMobileNumber(mobileNumber: string) {
    this.#lastMobileNumber.set(mobileNumber);
  }

  setTimerValue(timerValue: number) {
    this.#timerValue.set(timerValue);
  }

  setLastUserGuid(userGuid) {
    this.#lastUserGuid.set(userGuid);
  }

  setTimerSubscription(timerSubscription) {
    this.#timerSubscription.set(timerSubscription);
  }
}
